/**
 * Allow navigation to post-conversion pages only when a lead has been submitted.
 * Unlike FlowGuard, this checks for a lead result ID rather than form data,
 * since the lead store is reset after submission.
 *
 * @param context
 * @param context.store
 * @param context.redirect
 * @returns {*}
 */
export default function postConversionGuard({ store, redirect }) {
  const leadResultId = store.getters['lead/getResult']('id')

  if (!leadResultId) {
    return redirect('/')
  }
}
